export class PremiumResponse {
    totalCost: number;
    brokerCommission?: number;
    costs?: PremiumCost[];
    organizerCommission?: number;
    producerCommission?: number;
    totalPremium?: number;

    constructor(data?: PremiumResponse) {
        if (data) {
            Object.assign(this, data);
        }
    }
}

export class PremiumCost {
    amount: number;
    basis?: number;
    rateAmountTypeCode?: 'TaxSurcharge' | null;
    taxTypeCode?: string;

    constructor(data?: PremiumCost) {
        if (data) {
            Object.assign(this, data);
        }
    }
}